import deUnderscore from '../utils/deUnderscore'

export default function shopProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  return {
    productCategory: function(store) {
      if (this.hasOwnProperty('shopProductCategory') && this.shopProductCategory !== '') {
        return store.getters['config/getTermLabelFromEnum'](deUnderscore(this.shopProductCategory)) ?? ''
      } else {
        return ''
      }
    }
  }
}
